import { graphql } from 'gql'

export const CONFIRM_USER = graphql(`
  mutation confirmUser($input: ConfirmUserInput!, $canAccessGamConnection: Boolean!) {
    confirmUser(input: $input) {
      accessToken
      refreshToken

      user {
        ...AuthUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`)
